<mat-icon [ngClass]="{'green': active, 'red': !active}">{{active ? 'check_circle': 'cancel'}}</mat-icon>
